module.exports = __webpack_public_path__ + "static/media/logo-white-text-beta.a5dc51b0.png";